import { render } from "./Confetti.vue?vue&type=template&id=6231d7aa"
import script from "./Confetti.vue?vue&type=script&lang=js"
export * from "./Confetti.vue?vue&type=script&lang=js"

import "./Confetti.vue?vue&type=style&index=0&id=6231d7aa&lang=css"

import exportComponent from "/media/dev/Develop/Projects/Sjef/kiosk.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__